import type { ConfigsIntegrador } from '@/dados';
import { CAMPOS, descreverRegra } from '@/telas/custos/configuracao';

import { Capitulo, Linha, NaoPreenchido } from './ficha';

/* A estrutura de custos como a empresa configurou: as cinco linhas fixas e os
 * custos extras que ela criou.
 *
 * A regra é dita pela MESMA função da etapa de Custos. Escrever "R$ 350,00 por
 * kWp" de novo aqui daria duas frases para a mesma configuração, e elas
 * divergiriam no primeiro modo novo. */
export function Custos({ configs }: { configs: ConfigsIntegrador | null }) {
  const campos = configs?.campos ?? {};
  const extras = (configs?.extras ?? []).filter((extra) => extra.label);

  return (
    <Capitulo
      titulo="Estrutura de custos"
      descricao="Custo sem configuração vale zero no preço. O kit não entra aqui: vem do orçamento de cada projeto."
    >
      <div className="grid">
        {CAMPOS.map((campo) => (
          <Linha key={campo.chave} rotulo={campo.rotulo}>
            {descreverRegra(campos[campo.chave])}
          </Linha>
        ))}
        {extras.map((extra, indice) => (
          <Linha key={extra.id ?? indice} rotulo={extra.label ?? 'Extra'}>
            {descreverRegra(extra)}
          </Linha>
        ))}
      </div>
      {extras.length === 0 ? <NaoPreenchido>Nenhum custo extra criado.</NaoPreenchido> : null}
    </Capitulo>
  );
}
